// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"228":"f4d6fe1d693bccae","1444":"283e8a0f46be01c1","8457":"35aa28e32ee20c89","9297":"1d648a812406bfaf"}[chunkId] + ".js";
};